import styled from 'styled-components'
import { SPACING, BORDER_RADIUS, TYPOGRAPHY, FONT_WEIGHT } from '../../../styles/theme'

/**
 * Styled components for AccountSettingsSection
 */

export const SectionCard = styled.div`
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: ${BORDER_RADIUS.xl};
  padding: ${SPACING.xl};
  height: 100%;
  box-shadow: var(--shadow-card);
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: var(--shadow-card-hover);
  }
`

export const SectionHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${SPACING.md};
  margin-bottom: ${SPACING.xl};
  padding-bottom: ${SPACING.lg};
  border-bottom: 1px solid var(--color-border);
`

export const SectionIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: ${BORDER_RADIUS.lg};
  background: var(--color-bg-hover);
  color: var(--color-text-secondary);
  flex-shrink: 0;
`

export const SectionTitle = styled.h3`
  margin: 0 0 ${SPACING.xs} 0;
  font-size: ${TYPOGRAPHY.body.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-primary);
`

export const SectionDescription = styled.p`
  margin: 0;
  font-size: ${TYPOGRAPHY.caption.fontSize};
  color: var(--color-text-secondary);
`

export const DangerSectionCard = styled(SectionCard)`
  border-color: var(--color-error, #ff4d4f);
  border-width: 1px;

  &:hover {
    border-color: var(--color-error, #ff4d4f);
  }
`

export const DangerSectionIcon = styled(SectionIcon)`
  background: rgba(255, 77, 79, 0.1);
  color: var(--color-error, #ff4d4f);
`
